import { getAccessToken, refreshToken } from '@repo/api-client';
import { createFileRoute, redirect, useSearch } from '@tanstack/react-router';
import { useMemo } from 'react';
import { AdminApp } from '../components/AdminApp';
import { AdminErrorFallback } from '../components/shell/AdminErrorFallback';
import { AdminPendingFallback } from '../components/shell/AdminPendingFallback';
import { TaxonomyErrorBanner } from '../components/shell/TaxonomyErrorBanner';
import { AdminContext } from './_admin/-context';
import { useAdminQuestions } from './_admin/-useAdminQuestions';
import { useAdminTaxonomyState } from './_admin/-useAdminTaxonomyState';

export const Route = createFileRoute('/_admin')({
  beforeLoad: async ({ location }) => {
    if (!getAccessToken()) {
      try {
        await refreshToken();
      } catch {
        throw redirect({ to: '/login', search: { redirect: location.href } });
      }
    }
  },
  component: AdminLayoutRoute,
  errorComponent: AdminErrorFallback,
  pendingComponent: AdminPendingFallback,
});

function AdminLayoutRoute() {
  const { setId } = useSearch({ strict: false });
  const taxonomy = useAdminTaxonomyState();
  const questionState = useAdminQuestions(setId);

  const adminContextValue = useMemo(
    () => ({
      questions: questionState.questions,
      addQuestion: questionState.addQuestion,
      updateQuestion: questionState.updateQuestion,
      deleteQuestion: questionState.deleteQuestion,
      editingSet: questionState.editingSet,
      initialQuestionCount: questionState.initialQuestionCount,
      curricula: taxonomy.curricula,
      versions: taxonomy.versions,
      subjects: taxonomy.subjects,
      chapters: taxonomy.chapters,
      topics: taxonomy.topics,
      subtopics: taxonomy.subtopics,
      classes: taxonomy.classes,
      types: [],
      levels: [],
      sources: [],
      subSources: [],
      tags: [],
      years: [],
      isLoading: taxonomy.isLoading,
      isError: taxonomy.isError,
      error: taxonomy.error,
      refetchTaxonomy: taxonomy.refetch,
    }),
    [questionState, taxonomy],
  );

  return (
    <AdminContext.Provider value={adminContextValue}>
      <TaxonomyErrorBanner />
      <AdminApp editingSet={questionState.editingSet} />
    </AdminContext.Provider>
  );
}
